<template>
  <SearchPage />
</template>

<script>
import { defineComponent } from 'vue';

// Components
import SearchPage from '../components/SearchPage.vue';

export default defineComponent({
  name: 'MessageView',

  components: {
    SearchPage,
  },
});
</script>
